import React, { useState, useEffect } from 'react';
import TransactionOverview from "../records/TransactionOverview"


function SpotCheckTransactionOverview() {
    return (
        <>
           <TransactionOverview  isSpotCheck={true} />
        </>
    )
}

export default SpotCheckTransactionOverview;